import apiClient from './client';
import { getAllPages } from './pagination';

// References come in two kinds with overlapping IDs, so every call that targets
// one names its kind: "association-references" or "disease-references" (see
// TARGET_KINDS in constants/targetKinds.js).
//
// A reference is {id, pmid, link, measurement, like_count, liked_by_me,
// flag_counts, created_by, mine}, where measurement is
// {kind: "percentage", value, num_patients} or {kind: "subjective", value}.
// Values are per 100 people.

export const getAssociationReferences = (associationId) =>
  getAllPages(`/associations/${associationId}/references`);

// `measure` is "prevalence" or "incidence"
export const getDiseaseReferences = (diseaseId, measure) =>
  getAllPages(`/diseases/${diseaseId}/references`, { measure });

// {target: {kind: "association"|"disease", id}, measure, pmid?, link?, measurement}.
// Returns {reference, aggregate}: the parent's new combined value.
export const createReference = (payload) =>
  apiClient.post('/references', payload).then((r) => r.data);

// Only the changed fields, of {pmid, link, measurement}. Returns {reference, aggregate}.
export const updateReference = (kind, id, payload) =>
  apiClient.patch(`/${kind}/${id}`, payload).then((r) => r.data);

// Returns {aggregate}
export const deleteReference = (kind, id) =>
  apiClient.delete(`/${kind}/${id}`).then((r) => r.data);
